const form = {
  formId: "new-user-form",
  formField: {
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    period: {
      name: "period",
      label: "[04] Kỳ: Cổ tức, lợi nhuận được chia của năm",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ",
    },
    profits: {
      name: "profits",
      label: "[06] Lợi nhuận được chia",
      type: "boolean",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn lợi nhuận",
    },
    dividends: {
      name: "dividends",
      label: "[05] Cổ tức được chia",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập cổ t",
    },
    resolutions: {
      name: "resolutions",
      label: "Nghị quyết/ Quyết định số",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập Nghị quyết/ Quyết định số",
    },

    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },

    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxId2: {
      name: "taxId2",
      label: "[07] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label:
        "[09] Tên đơn vị phụ thuộc/địa điểm kinh doanh của hoạt động sản xất kinh doanh khác tỉnh nơi đóng trụ sở chính",
      type: "text",
      placeholder: "",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    date: {
      name: "date",
      label: "[01] Kỳ tính lợi nhuận sau thuế còn lại sau khi trích  lập các quỹ: 2022",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Ngày",
      invalidMsg: "Ngày không hợp lệ",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[08] Hợp đồng đại lý thuế/số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn hợp đồng đại lý thuế/số",
    },
  },
};

const AppendixForm = {
  formIdAppendix: "new-user-form",
  formFieldAppendix: {
    dateAppendix: {
      name: "dateAppendix",
      label: "[01] Kỳ tính lợi nhuận sau thuế còn lại sau khi trích  lập các quỹ: 2022",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Ngày",
      invalidMsg: "Ngày không hợp lệ",
    },
    taxpayerNameAppendix: {
      name: "taxpayerNameAppendix",
      label: "[02] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },

    taxIdAppendix: {
      name: "taxIdAppendix",
      label: "[03] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    profitsAppendix: {
      name: "profitsAppendix",
      label:
        "[04] Tổng số lợi nhuận sau thuế còn lại phải nộp NSNN trên tờ khai quyết toán (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng số lợi nhuận",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    revenueAppendix: {
      name: "revenueAppendix",
      label: "[05] Tổng doanh thu bán vé thực tế (đồng):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổng doanh thu",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
  },
};

export { form, AppendixForm };
